import React from "react";
import { Route } from "react-router-dom";
import { DomainView, CaseView } from "../layouts";
import { CreditorGroup, CreditorView } from "us.collection.creditor/layouts";
import {
  TransactionLayout,
  ArLayout,
} from "us.collection.transactions/layouts";
import Case from "us.collection.case";
import Creditor from "us.collection.creditor";
import Debtor from "us.collection.debtor";
import Partpayments from "us.collection.partpayments";
import Transactions from "us.collection.transactions";
import RoutinesAndActivities from "us.collection.routines-and-activities";
import Documents from "us.collection.documents";
import Admin from "us.collection.admin";
import { CaseType } from "us.helper/types/enums";
import { asyncRoutes } from "us.collection/functions";

import {
  MainSearch,
  UserRoleSettings,
  UserSettings,
  Home,
  FollowUps,
} from "./asyncRoutes";
import { BureauView } from "us.collection.admin/layouts";

export default (caseNo: number) => {
  const MainViewModules = [Admin];
  const CaseViewModules = [
    Case,
    Partpayments,
    RoutinesAndActivities,
    Transactions,
    Documents,
    Debtor,
  ];
  const TransactionViewModels = [Transactions];
  const CreditorModules = [Creditor];
  return [
    <Route key="search" path={"/search"} element={<MainSearch />} />,
    <Route
      key="/user-role-settings"
      path={"/user-role-settings"}
      element={<UserRoleSettings />}
    />,
    <Route
      key="/user-settings"
      path={"/user-settings"}
      element={<UserSettings />}
    />,
    <Route
      key="/follow-up"
      path={"/follow-up/:followUpId?/:filterId?"}
      element={<FollowUps />}
    />,
    <Route key="/" path={"/"} element={<Home />} />,
    // Layout route: DomainView as a wrapper for nested routes
    <Route key="DomainView" element={<DomainView isFollowup="false" />}>
      <Route
        key="creditor-routes"
        path="/creditor/:creditorId/*"
        element={<CreditorView.Layout />}
      >
        {CreditorModules.map(({ Routes }, index) => (
          <React.Fragment key={"creditor-" + index}>
            {asyncRoutes(
              caseNo,
              CaseType.C,
              Routes.Containers.creditorContainers
            )}
          </React.Fragment>
        ))}
      </Route>
      <Route
        key="creditor-group-routes"
        path="/creditor-group/:creditorGroupId/*"
        element={<CreditorGroup.Layout />}
      >
        {CreditorModules.map(({ Routes }, index) => (
          <React.Fragment key={"creditor-group-" + index}>
            {asyncRoutes(
              caseNo,
              CaseType.C,
              Routes.Containers.creditorGroupContainers
            )}
          </React.Fragment>
        ))}
      </Route>
      <Route
        key="payment-routes"
        path="/payment/:payment/*"
        element={<TransactionLayout />}
      >
        {TransactionViewModels.map(({ Routes }, index) => (
          <React.Fragment key={"payment-" + index}>
            {asyncRoutes(caseNo, CaseType.C, Routes.TransactionContainers)}
          </React.Fragment>
        ))}
      </Route>
      <Route key="ar-routes" path="/ar/:arNumber/*" element={<ArLayout />}>
        {TransactionViewModels.map(({ Routes }, index) => (
          <React.Fragment key={"ar-" + index}>
            {asyncRoutes(caseNo, CaseType.C, Routes.ArContainers)}
          </React.Fragment>
        ))}
      </Route>
      <Route
        key="case-routes"
        path="/case/:exCaseNo/*"
        element={<CaseView.Layout />}
      >
        {CaseViewModules.map(({ Routes }, index) => (
          <React.Fragment key={"case-" + index}>
            {asyncRoutes(caseNo, CaseType.C, Routes.Containers)}
          </React.Fragment>
        ))}
      </Route>
      <Route
        key="bureau-routes"
        path="/bureau/*"
        element={<BureauView.Layout />}
      >
        {MainViewModules.map(({ Routes }, index) => (
          <React.Fragment key={"bureau-" + index}>
            {asyncRoutes(caseNo, CaseType.C, Routes.BureauContainers)}
          </React.Fragment>
        ))}
      </Route>
    </Route>,
  ];
};
